import FingerprintRoundedIcon from '@mui/icons-material/FingerprintRounded';
import KeyRoundedIcon from '@mui/icons-material/KeyRounded';
import PhoneIphoneRoundedIcon from '@mui/icons-material/PhoneIphoneRounded';

export const METHOD_TYPES = [
  {
    key: 'otp',
    types: ['otp'],
    label: 'dashboard.accountSettings.twoStepVerification.methods.otp.label',
    name: 'dashboard.accountSettings.twoStepVerification.methods.otp.name',
    description: 'dashboard.accountSettings.twoStepVerification.methods.otp.description',
    recommendation: 'dashboard.accountSettings.twoStepVerification.methods.otp.recommendation',
    // The Enforce MFA Policy Action enrolls the factor named here.
    mfaFactor: 'otp',
    Icon: FingerprintRoundedIcon,
  },
  {
    key: 'sms',
    // A phone factor set to voice is still the user's phone, so it shows (and can be removed) here.
    types: ['sms', 'voice'],
    label: 'dashboard.accountSettings.twoStepVerification.methods.sms.label',
    name: 'dashboard.accountSettings.twoStepVerification.methods.sms.name',
    description: 'dashboard.accountSettings.twoStepVerification.methods.sms.description',
    Icon: PhoneIphoneRoundedIcon,
  },
  {
    key: 'securityKey',
    // Auth0 enrolls only one; a second is refused.
    types: ['webauthn-roaming'],
    label: 'dashboard.accountSettings.twoStepVerification.methods.securityKey.label',
    name: 'dashboard.accountSettings.twoStepVerification.methods.securityKey.name',
    description: 'dashboard.accountSettings.twoStepVerification.methods.securityKey.description',
    mfaFactor: 'webauthn-roaming',
    Icon: KeyRoundedIcon,
  },
];

// Banking accepts only a recent text message, so an account that requires MFA isn't offered these.
// The Enforce MFA Policy Action doesn't offer them either.
export const NOT_FOR_REQUIRE_MFA = new Set(['otp', 'securityKey']);

// A factor of any other type (e.g. "guardian", "push") has no row, so it can't be shown or removed.
export const RENDERED_METHOD_TYPES = new Set(METHOD_TYPES.flatMap(({ types }) => types));

// customers-api's refusal when the last MFA challenge is too old to remove MFA methods.
export const STEP_UP_REQUIRED = 'stepUpRequired';

// Set on the Security page URL the forced MFA login returns to, naming the dialog to reopen.
export const MFA_STEP_UP_PARAM = 'mfaStepUp';
export const MFA_STEP_UP_TURN_OFF = 'turnOff';
export const MFA_STEP_UP_REMOVE = 'remove';
export const MFA_STEP_UP_METHOD_PARAM = 'methodId';
